import { render } from "./AppDataDosen.vue?vue&type=template&id=6bb091f4"
import script from "./AppDataDosen.vue?vue&type=script&lang=js"
export * from "./AppDataDosen.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__